// Simple CSV downloader utility.
// Usage: downloadCSV(filename, csvString)
export default function downloadCSV(filename, csvText) {
  if (!filename || typeof filename !== 'string') {
    filename = 'download.csv';
  }

  if (typeof csvText !== 'string') {
    csvText = '';
  }

  // Add UTF-8 BOM for Excel compatibility
  const blob = new Blob(['\ufeff' + csvText], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  const url  = URL.createObjectURL(blob);

  link.style.display = 'none';
  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    URL.revokeObjectURL(url);
    link.remove();
  }, 0);
}
